export const API_BASE =
  process.env.REACT_APP_API_BASE && process.env.REACT_APP_API_BASE.trim().length > 0
    ? process.env.REACT_APP_API_BASE
    : '/api';

/** Base URL for static uploads. Use backend directly when set so links load from backend, not via frontend proxy. */
export const UPLOAD_BASE =
  process.env.REACT_APP_BACKEND_URL && process.env.REACT_APP_BACKEND_URL.trim().length > 0
    ? `${process.env.REACT_APP_BACKEND_URL.replace(/\/$/, '')}/api`
    : API_BASE;

